var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteinsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_904",
    "data-name": "Group 904",
    transform: "translate(-3021 -6571)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1058",
    "data-name": "Rectangle 1058",
    width: 24,
    height: 24,
    transform: "translate(3021 6571)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_073648578491af67fdc6a37bce022a16",
    "data-name": "073648578491af67fdc6a37bce022a16",
    d: "M7.076,10.613a3.538,3.538,0,1,1,3.537,3.538,3.538,3.538,0,0,1-3.537-3.538m-1.913,0a5.45,5.45,0,1,0,5.45-5.45,5.45,5.45,0,0,0-5.45,5.45m9.842-5.666a1.274,1.274,0,1,0,1.274-1.273,1.274,1.274,0,0,0-1.274,1.273m-8.68,14.3a5.863,5.863,0,0,1-1.971-.365,3.3,3.3,0,0,1-1.221-.794,3.28,3.28,0,0,1-.794-1.22A5.863,5.863,0,0,1,1.974,14.9c-.051-1.119-.062-1.455-.062-4.289s.011-3.169.062-4.289A5.89,5.89,0,0,1,2.34,4.353a3.3,3.3,0,0,1,.794-1.221,3.277,3.277,0,0,1,1.221-.794,5.863,5.863,0,0,1,1.971-.365c1.119-.051,1.455-.062,4.288-.062s3.169.011,4.289.062a5.89,5.89,0,0,1,1.971.365,3.29,3.29,0,0,1,1.221.794,3.294,3.294,0,0,1,.794,1.221,5.863,5.863,0,0,1,.365,1.971c.051,1.12.062,1.455.062,4.289s-.01,3.169-.062,4.289a5.885,5.885,0,0,1-.365,1.971,3.514,3.514,0,0,1-2.015,2.014,5.863,5.863,0,0,1-1.971.365c-1.119.051-1.455.062-4.289.062s-3.169-.01-4.288-.062M6.238.064A7.785,7.785,0,0,0,3.662.557a5.208,5.208,0,0,0-1.88,1.224A5.194,5.194,0,0,0,.557,3.662,7.785,7.785,0,0,0,.064,6.238C.012,7.369,0,7.731,0,10.613s.012,3.244.064,4.376a7.785,7.785,0,0,0,.493,2.576,5.19,5.19,0,0,0,1.224,1.88,5.2,5.2,0,0,0,1.88,1.224,7.79,7.79,0,0,0,2.576.493c1.132.051,1.493.064,4.376.064s3.244-.012,4.376-.064a7.785,7.785,0,0,0,2.576-.493,5.427,5.427,0,0,0,3.1-3.1,7.763,7.763,0,0,0,.493-2.576c.051-1.132.063-1.493.063-4.376s-.012-3.244-.063-4.376a7.785,7.785,0,0,0-.493-2.576,5.219,5.219,0,0,0-1.224-1.88A5.2,5.2,0,0,0,17.566.557,7.772,7.772,0,0,0,14.99.064C13.858.013,13.5,0,10.614,0S7.37.012,6.238.064",
    transform: "translate(3022.387 6572.387)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteinsta);
export default __webpack_public_path__ + "static/media/whiteinsta.161c7ca2f08c301a4b08d62f4eb0a69b.svg";
export { ForwardRef as ReactComponent };